require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./pharmacie-1-1-18-6.json") })
        }
      }, "path---pharmacie-1-1-18-6");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---pharmacie-1-1-18-6!./.cache/json/pharmacie-1-1-18-6.json
// module id = 519
// module chunks = 231608221292675